import { FC, PropsWithChildren } from 'react';
import ReactMarkdown from 'react-markdown';

import * as Styles from './markdown.module.scss';

interface MarkdownProps {
    text: string;
}

export const Markdown: FC<PropsWithChildren<MarkdownProps>> = ({ text }) => {
    return <ReactMarkdown className={Styles.markdown}>{text}</ReactMarkdown>;
};
